<script>
  // Shown on every screen while a Super admin views the dashboard as someone else, with the way
  // back — and, in the same place, why a requested view could not start.
  import { viewingAs } from "../viewAsStore.js";
  import { stopViewingAs, viewAsEntry } from "../viewAs.svelte.js";
  import { t } from "../i18n/i18n.svelte.js";

  // Fixed for the life of the page: starting and ending a view both reload.
  const viewing = viewingAs();
</script>

{#if viewing}
  <div class="view-as-banner" role="status">
    <span>{t(viewing.canWrite ? "act_as_banner" : "view_as_banner", { email: viewing.email })}</span>
    <button class="btn" onclick={stopViewingAs}>{t("view_as_return")}</button>
  </div>
{:else if viewAsEntry.error}
  <div class="view-as-banner failed" role="alert">
    <span>{t("view_as_failed", { message: viewAsEntry.error })}</span>
    <button class="btn" onclick={() => (viewAsEntry.error = null)}>{t("close")}</button>
  </div>
{/if}

<style>
  .view-as-banner {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px 16px;
    padding: 8px 20px;
    background: var(--accent);
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    text-align: center;
  }
  .view-as-banner.failed {
    background: #d24a4a;
  }
  .view-as-banner .btn {
    background: #fff;
    color: var(--accent);
    border-color: #fff;
    padding: 4px 12px;
  }
  .view-as-banner.failed .btn {
    color: #d24a4a;
  }
</style>
